import styled from "styled-components";

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  color: #ffffff;
  padding: 40px 20px;
  border-radius: 8px;
  height: 100%;
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 15px;
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ErrorMessage = styled.span`
  font-style: italic;
  font-size: 16px;
  line-height: 1.5;
  max-width: 400px;
`;

export const LinkContainer = styled.div`
  margin-top: 15px;
`;
